import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NotFound } from '@abb/uikit';
import React, { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { B2BRoutes } from 'routes/B2BRoutes';
import { BeyondBankingRoutes } from 'routes/BeyondBankingRoutes';
import { ContractSignRoutes } from 'routes/ContractSignRoutes';
import { DashboardRoutes } from 'routes/DashboardRoutes';
import { DGK_Routes } from 'routes/DGKRouters';
import { FatcaCrsRoutes } from 'routes/FatcaCrsRoutes';
import { InsuranceCardRoutes } from 'routes/InsuranceCardRoutes';
import { InternalTransferRoutes } from 'routes/InternalTransferRoutes';
import { MailBoxRoutes } from 'routes/MailBoxRoutes';
import { MarketplaceRoutes } from 'routes/MarketplaceRoutes';
import { MKR_Routes } from 'routes/MKR_Routes';
import { OtherServicesRoutes } from 'routes/OtherServicesRoutes';
import { ServiceCardRoutes } from 'routes/ServiceCardRoutes';
import { SmsEmailNotificationRoutes } from 'routes/SmsEmailNotificationRoutes';
import { SpecialCardRoutes } from 'routes/SpecialCardRoutes';
import { SpecialSalaryCardRoutes } from 'routes/SpecialSalaryCardRoutes';
import { StudentCardRoutes } from 'routes/StudentCardRoutes';
import { SwiftInboundTrackingRoutes } from 'routes/SwiftInboundTrackingRoutes';
import { UserProfileRoutes } from 'routes/UserProfileRoutes';
import { UsersRoutes } from 'routes/UsersRoutes';
import ErrorBoundary from './ErrorBoundary';
import { Layout } from './modules/Layout';
import { ProtectedRoutes } from './ProtectedRoutes';
import { RouteLoading } from './RouteLoading';
import { AccountOpeningRoutes } from './routes/AccountOpeningRoutes';
import { AccountsRoutes } from './routes/AccountsRoutes';
import { AnipayRoutes } from './routes/AnipayRoutes';
import { ApprovementRoutes } from './routes/ApprovementRoutes';
// import { BeyondBankingRoutes } from './routes/BeyondBankingRoutes';
import { BundleRoutes } from './routes/BundleRoutes';
import { CardsRoutes } from './routes/CardsRoutes';
import { CustomsServicesRoutes } from './routes/CustomsServicesRoutes';
import { DepositRoutes } from './routes/Deposit';
import { ERPRoutes } from './routes/ERPRoutes';
import { ExchangeRoutes } from './routes/ExchangeRoutes';
import { GppRoutes } from './routes/GppRoutes';
import { GuaranteeRoutes } from './routes/Guarantee';
import { InvestRoutes } from './routes/InvestRouters';
import { LoanRoutes } from './routes/LoanRoutes';
import { OrderRoutes } from './routes/OrderRoutes';
import { OwnTransferRoutes } from './routes/OwnTransferRoutes';
import { PaymentRoutes } from './routes/PaymentRoutes';
import { POSAnalyticsRoutes } from './routes/POSAnalyticsRoutes';
import { PosRoutes } from './routes/PosRouters';
import { ReportsRoutes } from './routes/ReportsRoutes';
import { SalaryTransferRoutes } from './routes/SalaryTransferRoutes';
import { SupplyChainRoutes } from './routes/SupplyChainRoutes';
import { TaxAssistanceRoutes } from './routes/TaxAssistanceRoutes';
export const AppRouter = ()=>{
    const { t } = useTranslation();
    const routes = useMemo(()=>[
            //Anipay
            ...AnipayRoutes(),
            //Order
            ...OrderRoutes(),
            //Payment
            ...PaymentRoutes(),
            //Cards
            ...CardsRoutes(),
            //Special card
            ...SpecialCardRoutes(),
            //Account opening
            ...AccountOpeningRoutes(),
            //Insurance card
            ...InsuranceCardRoutes(),
            //Service card
            ...ServiceCardRoutes(),
            //Special salary card
            ...SpecialSalaryCardRoutes(),
            //Student card
            ...StudentCardRoutes(),
            //Accounts
            ...AccountsRoutes(),
            //GPP
            ...GppRoutes(),
            //Exchange
            ...ExchangeRoutes(),
            //Reports
            ...ReportsRoutes(),
            //Approvements
            ...ApprovementRoutes(),
            //Deposit
            ...DepositRoutes(),
            //Guarantee
            ...GuaranteeRoutes(),
            //Loan
            ...LoanRoutes(),
            //Bundle
            ...BundleRoutes(),
            //UserProfile
            ...UserProfileRoutes(),
            //Users
            ...UsersRoutes(),
            //MailBox
            ...MailBoxRoutes(),
            //Dashboard
            ...DashboardRoutes(),
            //OtherServices
            ...OtherServicesRoutes(),
            //PosTerminal
            ...PosRoutes(),
            //POSAnalytics
            ...POSAnalyticsRoutes(),
            //Investment
            ...InvestRoutes(),
            //DGK
            ...DGK_Routes(),
            //BeyondBanking
            ...BeyondBankingRoutes(),
            //TaxAssistance
            ...TaxAssistanceRoutes(),
            //CustomsServicesRoutes
            ...CustomsServicesRoutes(),
            //SmsEmailNotification
            ...SmsEmailNotificationRoutes(),
            //B2B
            ...B2BRoutes(),
            //MKR
            ...MKR_Routes(),
            //FATCA CRS
            ...FatcaCrsRoutes(),
            //SupplyChain
            ...SupplyChainRoutes(),
            //ContractSign
            ...ContractSignRoutes(),
            //SwiftInboundTracking
            ...SwiftInboundTrackingRoutes(),
            //ERP
            ...ERPRoutes(),
            //OwnTransfer
            ...OwnTransferRoutes(),
            //Marketplace
            ...MarketplaceRoutes(),
            //InternalTransfer
            ...InternalTransferRoutes(),
            //SalaryTransfer
            ...SalaryTransferRoutes()
        ], []);
    return /*#__PURE__*/ _jsxs(Routes, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                path: "/",
                element: /*#__PURE__*/ _jsx(ProtectedRoutes, {
                    condition: false
                })
            }),
            routes.filter((route)=>(route === null || route === void 0 ? void 0 : route.condition) || (route === null || route === void 0 ? void 0 : route.condition) == undefined).map((route, index)=>{
                const getRoutes = (routes, parentPath)=>{
                    return routes === null || routes === void 0 ? void 0 : routes.map((route, index)=>{
                        const uniqueKey = `${parentPath}-${index}-${route === null || route === void 0 ? void 0 : route.path}`;
                        if (!(route === null || route === void 0 ? void 0 : route.path)) {
                            return /*#__PURE__*/ _jsx(Route, {
                                index: true,
                                element: /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: /*#__PURE__*/ _jsx(RouteLoading, {}),
                                    children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                                        children: route.component
                                    }, uniqueKey)
                                })
                            }, uniqueKey);
                        }
                        return /*#__PURE__*/ _jsx(Route, {
                            path: route.path,
                            element: /*#__PURE__*/ _jsx(Suspense, {
                                fallback: /*#__PURE__*/ _jsx(RouteLoading, {}),
                                children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                                    children: route.component
                                }, index)
                            }),
                            children: (route === null || route === void 0 ? void 0 : route.nestedRoute) && getRoutes(route.nestedRoute, route.path)
                        }, uniqueKey);
                    });
                };
                const LayoutWrapper = !route.path.includes('trade-platform') ? Layout : React.Fragment;
                return /*#__PURE__*/ _jsx(Route, {
                    path: route.path,
                    element: /*#__PURE__*/ _jsx(LayoutWrapper, {
                        children: /*#__PURE__*/ _jsx(Suspense, {
                            fallback: /*#__PURE__*/ _jsx(RouteLoading, {}),
                            children: /*#__PURE__*/ _jsx(ProtectedRoutes, {
                                condition: route === null || route === void 0 ? void 0 : route.condition,
                                children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                                    children: route.component
                                }, index)
                            })
                        })
                    }),
                    children: (route === null || route === void 0 ? void 0 : route.nestedRoute) && getRoutes(route === null || route === void 0 ? void 0 : route.nestedRoute, route.path)
                }, index);
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "*",
                element: /*#__PURE__*/ _jsx(Layout, {
                    children: /*#__PURE__*/ _jsx(NotFound, {
                        locales: {
                            title: t('404.title'),
                            description: t('404.description'),
                            button_name: t('404.button_name')
                        }
                    })
                })
            })
        ]
    });
};
